<template>
	<div>
		<div class="mainCont">
			<div class="headTabs">
				<el-tabs v-model="activeTab">
					<el-tab-pane label="渠道维度" value="1" name="1"></el-tab-pane>
					<el-tab-pane label="媒体维度" value="2" name="2"></el-tab-pane>
				</el-tabs>
			</div>
			<!-- keep-alive：切换 tab 时缓存子组件实例，避免 v-if 销毁重建导致筛选丢失与重复请求 mounted -->
			<keep-alive>
				<budgetDimension v-if="activeTab === '1'" key="timeShareReport-budget" />
				<mediaDimension v-if="activeTab === '2'" key="timeShareReport-media" />
			</keep-alive>
		</div>
	</div>
</template>

<script>
	import budgetDimension from './budgetDimension.vue';
	import mediaDimension from './mediaDimension.vue';

	export default {
		name: "TimeShareReport",
		components: {
			budgetDimension,
			mediaDimension,
		},
		data() {
			return {
				activeTab: '1',
			}
		},
	}
</script>

<style scoped>
	.mainCont {
		/* background: #FFFFFF; */
		border-radius: 4px;
		margin-top: 0px;
		padding: 20px 10px;
		padding-top: 0;
		box-sizing: border-box;
	}

	.headTabs {
		padding: 0 20px;
		padding-top: 10px;
		margin: 10px 0;
		font-size: 16px;
		background: #ffffff;
	}
	.headTabs /deep/ .el-tabs__item{
		font-size: 16px;
	}
</style>
